export { default, getServerSideProps } from './root';
